import CreateSeedAudienceAdAccountSelect from './CreateSeedAudiencesAdAccountSelect.Container';

export default CreateSeedAudienceAdAccountSelect;
